import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, setDoc, arrayUnion } from "firebase/firestore";
import { LanguageProvider } from "./LanguageContext";
import Landing from "./Landing";
import Login from "./Login";
import Register from "./Register";
import Dashboard from "./Dashboard";
import Admin from "./Admin";

function AppContent() {
  const [screen, setScreen] = useState("loading");

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const now = Date.now();
        await setDoc(doc(db, "users", user.uid), {
          loginHistory: arrayUnion({ loginAt: new Date().toISOString(), timestamp: now }),
          lastSeen: now,
        }, { merge: true });
        // Small delay so Firestore write settles before Dashboard fetches
        await new Promise(resolve => setTimeout(resolve, 300));
        setScreen("dashboard");
      } else {
        setScreen("landing");
      }
    });
  }, []);

  if (screen === "loading") return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Loading...</p>
    </div>
  );
  if (screen === "landing") return <Landing onSignIn={() => setScreen("login")} onRegister={() => setScreen("register")} />;
  if (screen === "login") return <Login onLogin={() => setScreen("dashboard")} onRegister={() => setScreen("register")} onBack={() => setScreen("landing")} />;
  if (screen === "register") return <Register onRegister={() => setScreen("dashboard")} onLogin={() => setScreen("login")} onHome={() => setScreen("landing")} />;
  if (screen === "admin") return <Admin onBack={() => setScreen("dashboard")} />;
  return <Dashboard onAdmin={() => setScreen("admin")} />;
}

export default function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}